module.exports = __webpack_public_path__ + "img/as.f7b5af8f.png";